export default "__VITE_ASSET__Bmn7x6IP__"